import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast, TOAST_ERROR, TOAST_SUCCESS, FIVE_SECONDS, TEN_SECONDS } from 'lib/utils';
import { makeRemotePatchQueueRequestPriority } from 'main/factories/usecases';

const patchRequestPriority = async ({ id, priority }: { id: string; priority: 'Blocker' | 'Normal' }) => {
  const service = makeRemotePatchQueueRequestPriority(id);
  return service.patch({ priority });
};

export const usePatchRequestPriorityMutation = (onSuccessCallback?: (data: any) => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchRequestPriority,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries();
      showToast('Priority updated', TOAST_SUCCESS, FIVE_SECONDS);
      if (onSuccessCallback) onSuccessCallback(data);
    },
    onError: (error: any) => {
      showToast(error.message || 'Error while updating priority', TOAST_ERROR, TEN_SECONDS);
    },
  });
};
